import React, {useState, useEffect, useRef} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import axios from "axios";

const InventoryGrnListComponent = (props) => {

  const {t, purchaseOrderId} = props;
  const history = useHistory();
  const {entity, action, id} = useParams();
  const [inventoryGrns, setInventoryGrns] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rows, setRows] = useState(Number(process.env.REACT_APP_LIST_ROW_DEFAULT));
  const dt = useRef(null);
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: rows,
    page: 0,
    sortField: 'id',
    sortOrder: -1,
  });

  let loadLazyTimeout = null;

  // const buildPoFilter = () => {
  //   if (!purchaseOrderId) return '';
  //   return `&search[purchase_order][operator]==&search[purchase_order][value]=${encodeURIComponent(purchaseOrderId)}`;
  // }
  // const buildPoFilter = () => {
  //   const v = purchaseOrderId ?? id;
  //   if (!v || v === 'undefined' || v === 'create') return '';
  //   return `&search[purchase_order][operator]==&search[purchase_order][value]=${encodeURIComponent(v)}`;
  // }
  const buildPoFilter = () => {
    if (!purchaseOrderId) return '';
    return `&search[purchase_order][operator]==&search[purchase_order][value]=${encodeURIComponent(purchaseOrderId)}`;
  };

  const loadLazyData = () => {
    setLoading(true);
    if (loadLazyTimeout) {
      clearTimeout(loadLazyTimeout);
    }
    loadLazyTimeout = setTimeout(() => {
      let query = window.App.transformQueryParams(lazyParams)
      if (query && !query.startsWith('?')) query = '?' + query;
      const poFilter = buildPoFilter(purchaseOrderId);

      const url = '/api/v2/inventory-grn' + query + poFilter;
      console.log('GRN URL:', url);

      apiCall('get', '/api/v2/inventory-grn' + query + poFilter)
        .then(response => {
          setTotalRecords(response.data.data.total_item_count);
          setInventoryGrns(response.data.data.items)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }, Math.random() * 1000 + 250);
  }
  const onPage = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onSort = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onFilter = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParams(_lazyParams);
  }
  const pager = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: Number(process.env.REACT_APP_LIST_ROW_OP1), value: Number(process.env.REACT_APP_LIST_ROW_OP1)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP2), value: Number(process.env.REACT_APP_LIST_ROW_OP2)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP3), value: Number(process.env.REACT_APP_LIST_ROW_OP3)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP4), value: Number(process.env.REACT_APP_LIST_ROW_OP4)},
      ];

      return (
        <>
          {/*<span className="p-mx-1" style={{color: 'var(--text-color)', userSelect: 'none'}}>Tételek egy oldalon: </span>*/}
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => setRows(e.target.value)}
                    appendTo={document.body}/>
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center'}}>
                        {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        {localStorage.getItem('roles').toString().includes('role_') &&
          <Button icon="pi pi-eye" className="p-button-default p-ml-2"
                  tooltip={t('view')} tooltipOptions={{position: 'left'}}
                  onClick={() => {
                    if (entity === 'inventory-grn') {
                      history.push('/inventory/inventory-grn/read/' + rowData.id)
                    }
                    if (entity === 'purchase-order') {
                      history.push('/procurement/' + entity + "/" + action + "/" + id + '?read=inventorygrn&inventorygrnId=' + rowData.id)
                    }
                  }}/>
        }
        {entity === 'inventory-grn' &&
          <>
            {localStorage.getItem('roles').toString().includes('role_inventory_grn_write') &&
              <Button icon="pi pi-pencil" className="  p-button-warning p-ml-2"
                      tooltip={t('edit')} tooltipOptions={{position: 'left'}}
                      disabled={rowData.closed}
                      onClick={() => {
                        if (entity === 'inventory-grn') {
                          history.push('/inventory/inventory-grn/update/' + rowData.id)
                        }
                      }}/>
            }
            {/*{localStorage.getItem('roles').toString().includes('role_') &&*/}
            {/*  <Button icon="pi pi-trash" className="p-button-danger p-ml-2"*/}
            {/*          tooltip={t('delete')} tooltipOptions={{position: 'left'}}*/}
            {/*          onClick={() => {*/}
            {/*            if (window.confirm('A törlés megerősítésére van szükség!')) {*/}
            {/*              setLoading(true);*/}
            {/*              apiCall('delete', '/api/v2/inventory-grn/' + rowData.id)*/}
            {/*                .then(response => {*/}
            {/*                  window.App.toastShow('success', 'Sikeres törlés!');*/}
            {/*                  window.App.setState({rerenderInventoryGrnList: Math.random()})*/}
            {/*                })*/}
            {/*                .catch(error => {*/}
            {/*                  window.App.toastShow('error', t('error'), error.toString(), '', error.response);*/}
            {/*                })*/}
            {/*                .finally(() => {*/}
            {/*                  setLoading(false);*/}
            {/*                })*/}
            {/*            }*/}
            {/*          }}*/}
            {/*  />*/}
            {/*}*/}
          </>
        }
      </React.Fragment>
    );
  }

  useEffect(() => {
    loadLazyData();
  }, [lazyParams, window.App.state.rerenderInventoryGrnList, purchaseOrderId])

  return (
    <>
      <DataTable size={localStorage.getItem('scale')}
                 emptyMessage={t('noResults')}
                 value={inventoryGrns} paginator first={lazyParams.first} totalRecords={totalRecords} onPage={onPage}
                 onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                 onFilter={onFilter} filters={lazyParams.filters} loading={loading} lazy
                 paginatorTemplate={pager} rows={rows}
                 autoLayout={true}
                 filterDisplay="row"
                 responsiveLayout="scroll"
                 stripedRows
                 ref={dt}
                 dataKey="id"
      >

        <Column field="grn_number" header={t('columnSerialNumber')} bodyClassName="col-body-font-bold" sortable filter></Column>
        <Column field="created_by.name" header={t('columnUser')} sortable filter
                body={(row) => row?.created_by?.name}></Column>
        <Column field="date" header={t('columnDateAndTime')} sortable filter body={(row) => row?.date}></Column>
        <Column field="closed" header={t('columnClosed')} sortable filter body={(row) => row?.closed ? props.t('yes') : props.t('no')}></Column>
        <Column field="purchase_order.purchase_order_number" header={t('columnPurchaseOrder')} sortable filter
                body={(row) => row?.purchase_order?.purchase_order_number}></Column>
        <Column field="delivery_note.document_number" header={t('columnDeliveryNote')} sortable filter
                body={(row) => row?.delivery_note?.document_number}></Column>
        <Column field="receipt.receipt_number" header={t('columnInvoice')} sortable filter
                body={(row) => row?.receipt?.receipt_number}></Column>


        <Column body={actionBodyTemplate} className={"p-py-0 p-text-right p-text-nowrap"}></Column>


        {/* <Column field="name" header={t('columnName')} sortable filter></Column>




        <Column field="created_at" header={t('columnCreatedAt')} sortable body={(rowData) => {
          return (
            <>{window.App.formatDateValue(rowData.created_at)}</>
          )
        }}></Column>
        <Column field="updated_at" header={t('columnUpdatedAt')} sortable body={(rowData) => {
          return (
            <>{window.App.formatDateValue(rowData.updated_at)}</>
          )
        }}></Column>
        <Column body={actionBodyTemplate} className={"p-py-0 p-text-right p-text-nowrap"}></Column> */}
      </DataTable>
    </>
  )
}
export default withTranslation('common')(InventoryGrnListComponent);
